import React from 'react'
import './claims.css'

const Claims = () => {
  return (
    <div className="claims-container">
                <h1>INSURANCE CLAIMS</h1>
                <p>
                We understand that dealing with insurance claims and deductibles can be stressful. 
                That's why we proudly offer to waive your insurance deductible for qualifying repairs. 
                Our goal is to make the repair process as seamless and affordable as possible, allowing you to get your vehicle back on the road without the added financial burden. 
                Whether you're dealing with minor dents or more extensive collision damage, our experienced technicians are here to provide high-quality repairs, backed by excellent customer service. 
                Trust us to take care of the details and give you peace of mind during your repair process.
                We'll work directly with your insurance company, handling the paperwork and coordinating the claim on your behalf. 
                All you need to do is bring your vehicle in, and we'll take care of the rest. 
                Whether it's estimating the damage or submitting the claim, we ensure a fast, hassle-free experience so you can get back on the road with minimal disruption.
                </p>
            </div>
  )
}

export default Claims